// extracted by mini-css-extract-plugin
export default {"order":"order_order__M+tn3","order__inner":"order_order__inner__pT0vK"};